<template>
  <nav class="AtlasIndicatorControls">
    <indicator-group
      :categories="categories"
      :links="links"
      @update:indicator="handleUpdateIndicator"
    ></indicator-group>

    <geo-controls
      v-if="geoControls && areGeoSectionsLoaded"
      :primary-geo="primaryGeo"
      :secondary-geo="secondaryGeo"
      :geo-sections="geoSections"
      :geo-limit="geoLimit"
      :allow-geo-compare="breakdown.allowGeoCompare"
      :is-geo-compare-default-enabled="isGeoCompareDefaultEnabled"
      @update:geoType="onGeoTypeUpdate"
      @update:primary-geo="onPrimaryGeoUpdate"
      @update:secondary-geo="onSecondaryGeoUpdate"
      class="AtlasIndicatorControls-chooseGeo"
    />
  </nav>
</template>

<script>
import { defineComponent } from 'vue';
import { mapState, mapGetters, mapActions } from 'vuex';

import GeoControls from './geo-controls.vue';
import IndicatorGroup from '../indicator-group/index.vue';

export default defineComponent({
  name: 'atlas-indicator-controls',

  inject: {
    widgetContext: { from: 'widgetContext' },
  },

  components: {
    GeoControls,
    IndicatorGroup,
  },

  props: {
    indicatorId: {
      type: String,
      required: true,
    },
    breakdownSlug: {
      type: String,
      required: true,
    },

    categories: {
      type: Array,
      default: () => [],
    },

    links: {
      type: Array,
      default: () => [],
    },

    geoLimit: {
      type: Number,
      default: 1000,
    },
    geoControls: Boolean,

    isGeoCompareDefaultEnabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState('breakdown', ['primaryGeo', 'secondaryGeo']),

    ...mapGetters('indicator', ['geoSections']),

    ...mapGetters('breakdown', ['selectedBreakdownId', 'breakdownById']),

    activeBreakdownId() {
      return this.selectedBreakdownId || this.breakdownSlug;
    },

    breakdown() {
      return this.breakdownById(this.activeBreakdownId);
    },

    displayRev() {
      // display group version
      return this.widgetContext.value.displayGroupRevision;
    },

    areGeoSectionsLoaded() {
      return this.geoSections && this.geoSections.length;
    },
  },

  methods: {
    ...mapActions({
      fetchIndicatorGeoSelectorOptions:
        'indicator/fetchIndicatorGeoSelectorOptions',
      updateCompareGeoCode: 'indicator/updateCompareGeoCode',
    }),

    handleUpdateIndicator(value) {
      if (value && value.href) window.location = value.href;
    },

    onGeoTypeUpdate(option) {
      // fetch missing geo selector options
      this.fetchIndicatorGeoSelectorOptions({
        id: this.indicatorId,
        displayRev: this.displayRev,
        geoCode: option.id,
      });
    },

    pushQueryToRouter(value, key) {
      return this.$router.push({
        ...this.$route,
        query: { ...this.$route.query, [key]: value },
      });
    },

    onPrimaryGeoUpdate(option) {
      this.pushQueryToRouter(option?.id, 'geo');
    },

    async onSecondaryGeoUpdate(option) {
      await this.pushQueryToRouter(option?.id, 'geo_compare');

      this.updateCompareGeoCode(option?.id);
    },
  },
});
</script>

<style lang="scss">
.AtlasIndicatorControls {
  @media screen and (min-width: 1024px) {
    display: flex;
  }

  &-chooseIndicator {
    flex: 330;
    margin-bottom: 15px;

    @media screen and (min-width: 640px) {
      display: flex;
    }

    @media screen and (min-width: 1024px) {
      margin-bottom: 0;
    }
  }

  &-chooseGeo {
    flex: 620;
  }

  &-ctrl {
    margin-right: 30px;

    &--category {
      flex: 1;
      margin-bottom: 15px;

      @media screen and (min-width: 640px) {
        margin-bottom: 0;
      }
    }

    &--indicator {
      flex: 2;
    }
  }

  &-label {
    margin-bottom: 11px;
    color: color(shadow);
    font-size: 14px;
    font-weight: normal;
    white-space: nowrap;
  }
}
</style>
